import agent from '../agent';
import { VOTES_LOADING,
         VOTES_LOADED,
         PARTIES_VOTES_LOADING,
         PARTIES_VOTES_LOADED,
         VOTE_CREATED_SUCCESSFULLY,
         AVERAGES_VOTES_LOADING,
         AVERAGES_VOTES_LOADED,
         PARTIES_VOTE_CREATED_SUCCESSFULLY } from '../constants/actionTypes';

export const fetchVotesStart = () => ({
  type: VOTES_LOADING,
})

export const fetchVotesFinished = (payload) => ({
  type: VOTES_LOADED,
  payload
})

export const fetchVotesList = (dispatch) => (polliesIDs) => {
  dispatch(fetchVotesStart());
  agent.Pollies.getPolliesVotes(polliesIDs).then(res => {
    dispatch(fetchVotesFinished(res));
  }, err => {
    dispatch(fetchVotesFinished(err));
  })
};

/* ----------- fetch Averages VotesList ---------- */
export const fetchAveragesVotesStart = () => ({
  type: AVERAGES_VOTES_LOADING,
})

export const fetchAveragesVotesFinished = (payload) => ({
  type: AVERAGES_VOTES_LOADED,
  payload
})

export const fetchAveragesVotesList = (dispatch) => (personId) => {
  dispatch(fetchAveragesVotesStart());
  agent.Pollies.getAveragesVotes(personId).then(res => {
    dispatch(fetchAveragesVotesFinished(res));
  }, err => {
    dispatch(fetchAveragesVotesFinished(err));
  })
};

export const voteCreatedSuccessfully = (payload) => {
  return {
    type: VOTE_CREATED_SUCCESSFULLY,
    payload
  }
}

export const createVote = (dispatch, getState) => (curVote) => {
  const store = getState();
  let polliesIDs = store.pollyList ? store.pollyList.pollies.map(res => {
    return res.personID
  }) : null

  agent.Pollies.createVote(curVote).then(res => {
    dispatch(voteCreatedSuccessfully(res));
    fetchVotesList(dispatch)(polliesIDs)
  }, err => {
    dispatch(voteCreatedSuccessfully(err));
  })
}



export const createSingleVote = (dispatch, getState) => (curVote, personId) => {
    let polliesID = personId;
    agent.Pollies.createVote(curVote).then(res => {
        dispatch(voteCreatedSuccessfully(res));
        fetchVotesList(dispatch)(polliesID)
    }, err => {
        dispatch(voteCreatedSuccessfully(err));
    })
}

/* -----------------start create Parties Vote---------------------------*/
export const fetchPartyVotesStart = () => ({
    type: PARTIES_VOTES_LOADING,
})

export const fetchPartyVotesFinished = (payload) => ({
    type: PARTIES_VOTES_LOADED,
    payload
})

export const fetchPartyVotesList = (dispatch) => (polliesIDs) => {
    dispatch(fetchPartyVotesStart());
    agent.Pollies.getPartyVotes(polliesIDs).then(res => {
        dispatch(fetchPartyVotesFinished(res));
    }, err => {
        dispatch(fetchPartyVotesFinished(err));
    })
};

export const partiesVoteCreatedSuccessfully = (payload) => {
    return {
        type: PARTIES_VOTE_CREATED_SUCCESSFULLY,
        payload
    }
}

export const createPartiesVote = (dispatch) => (curVote, personId) => {
    agent.Pollies.createPartiesVote(curVote).then(res => {
        dispatch(partiesVoteCreatedSuccessfully(res));
        fetchPartyVotesList(dispatch)(personId)
    }, err => {
        dispatch(partiesVoteCreatedSuccessfully(err));
    })
}

/* --------------end create Parties Vote---------------*/